import React from 'react';
import PropTypes from 'prop-types';

import { ExampleContainer } from './styles';

function TwitchExample({ styles }) {
  const { message, user } = styles;

  return (
    <ExampleContainer>
      <div className="chat-line__message">
        <div className="chat-line__message-container">
          <div
            className="chat-line__no-background"
            style={{ display: 'inline' }}
          >
            <div
              className="chat-line__username-container"
              style={{ display: 'inline-block' }}
            >
              {!!user.showIcons && (
                <span style={{ display: 'inline' }}>
                  <div style={{ display: 'inline' }}>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        borderRadius: 0,
                        color: 'inherit',
                        font: 'inherit',
                        padding: '0 3px 0 0',
                      }}
                    >
                      <img
                        alt="GLHF Pledge"
                        aria-label="GLHF Pledge badge"
                        className="chat-badge"
                        src="https://static-cdn.jtvnw.net/badges/v1/3158e758-3cb4-43c5-94b3-7639810451c5/1"
                        srcSet="https://static-cdn.jtvnw.net/badges/v1/3158e758-3cb4-43c5-94b3-7639810451c5/1 1x, https://static-cdn.jtvnw.net/badges/v1/3158e758-3cb4-43c5-94b3-7639810451c5/2 2x, https://static-cdn.jtvnw.net/badges/v1/3158e758-3cb4-43c5-94b3-7639810451c5/3 4x"
                      />
                    </button>
                  </div>
                </span>
              )}
              <span className="chat-line__username" role="button" tabIndex="0">
                <span>
                  <span
                    className="chat-author__display-name"
                    style={{
                      color: 'rgb(218, 165, 32)',
                      fontSize: `${user.size}px`,
                      letterSpacing: `${user.letterSpacing}px`,
                      textShadow: `0px 0px ${user.shadowSize}px ${user.shadowColor}`,
                      position: 'relative',
                      top: '-3px',
                    }}
                  >
                    cxanapy
                  </span>
                </span>
              </span>
            </div>
            <span
              aria-hidden="true"
              style={{
                position: 'relative',
                top: '-3px',
              }}
            >
              :{' '}
            </span>
            <span
              data-a-target="chat-line-message-body"
              style={{
                display: 'inline',
                color: message.color,
                fontSize: `${message.size}px`,
                letterSpacing: `${message.letterSpacing}px`,
                textShadow: `0px 0px ${message.shadowSize}px ${message.shadowColor}`,
              }}
            >
              <span
                className="text-fragment"
                style={{
                  position: 'relative',
                  top: '-3px',
                }}
              >
                Saludos desde Thailand
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="chat-line__message" style={{ marginTop: '2px' }}>
        <div className="chat-line__message-container">
          <div
            className="chat-line__no-background"
            style={{ display: 'inline' }}
          >
            <div
              className="chat-line__username-container"
              style={{ display: 'inline-block' }}
            >
              {!!user.showIcons && (
                <span style={{ display: 'inline' }}>
                  <div style={{ display: 'inline' }}>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        borderRadius: 0,
                        color: 'inherit',
                        font: 'inherit',
                        padding: '0 2px 0 0',
                      }}
                    >
                      <img
                        alt="Moderator"
                        aria-label="Moderator badge"
                        className="chat-badge"
                        src="https://static-cdn.jtvnw.net/badges/v1/3267646d-33f0-4b17-b3df-f923a41db1d0/1"
                        srcSet="https://static-cdn.jtvnw.net/badges/v1/3267646d-33f0-4b17-b3df-f923a41db1d0/1 1x, https://static-cdn.jtvnw.net/badges/v1/3267646d-33f0-4b17-b3df-f923a41db1d0/2 2x, https://static-cdn.jtvnw.net/badges/v1/3267646d-33f0-4b17-b3df-f923a41db1d0/3 4x"
                      />
                    </button>
                  </div>
                  <div style={{ display: 'inline' }}>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        borderRadius: 0,
                        color: 'inherit',
                        font: 'inherit',
                        padding: '0 2px 0 0',
                      }}
                    >
                      <img
                        alt="1-Year Subscriber"
                        aria-label="1-Year Subscriber badge"
                        className="chat-badge"
                        src="https://static-cdn.jtvnw.net/badges/v1/17f59cd4-06ad-4334-8c15-199919a4065b/1"
                        srcSet="https://static-cdn.jtvnw.net/badges/v1/17f59cd4-06ad-4334-8c15-199919a4065b/1 1x, https://static-cdn.jtvnw.net/badges/v1/17f59cd4-06ad-4334-8c15-199919a4065b/2 2x, https://static-cdn.jtvnw.net/badges/v1/17f59cd4-06ad-4334-8c15-199919a4065b/3 4x"
                      />
                    </button>
                  </div>
                  <div style={{ display: 'inline' }}>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        borderRadius: 0,
                        color: 'inherit',
                        font: 'inherit',
                        padding: '0 2px 0 0',
                      }}
                    >
                      <img
                        alt="Verified"
                        aria-label="Verified badge"
                        className="chat-badge"
                        src="https://static-cdn.jtvnw.net/badges/v1/d12a2e27-16f6-41d0-ab77-b780518f00a3/1"
                        srcSet="https://static-cdn.jtvnw.net/badges/v1/d12a2e27-16f6-41d0-ab77-b780518f00a3/1 1x, https://static-cdn.jtvnw.net/badges/v1/d12a2e27-16f6-41d0-ab77-b780518f00a3/2 2x, https://static-cdn.jtvnw.net/badges/v1/d12a2e27-16f6-41d0-ab77-b780518f00a3/3 4x"
                      />
                    </button>
                  </div>
                </span>
              )}
              <span className="chat-line__username" role="button" tabIndex="0">
                <span>
                  <span
                    className="chat-author__display-name"
                    style={{
                      color: 'rgb(255, 41, 97)',
                      fontSize: `${user.size}px`,
                      letterSpacing: `${user.letterSpacing}px`,
                      textShadow: `0px 0px ${user.shadowSize}px ${user.shadowColor}`,
                      position: 'relative',
                      top: '-3px',
                    }}
                  >
                    MikelGartziia
                  </span>
                </span>
              </span>
            </div>
            <span
              aria-hidden="true"
              style={{
                position: 'relative',
                top: '-3px',
              }}
            >
              :{' '}
            </span>
            <span
              data-a-target="chat-line-message-body"
              style={{
                display: 'inline',
                color: message.color,
                fontSize: `${message.size}px`,
                letterSpacing: `${message.letterSpacing}px`,
                textShadow: `0px 0px ${message.shadowSize}px ${message.shadowColor}`,
              }}
            >
              <span
                className="text-fragment"
                style={{
                  position: 'relative',
                  top: '-3px',
                }}
              >
                Buen dia!
              </span>
              <div
                className="chat-line__message--emote-button"
                style={{
                  display: ' inline-flex',
                  position: 'relative',
                  top: '3px',
                }}
              >
                <div>
                  <span data-a-target="emote-name">
                    <div className="chat-image__container">
                      <img
                        alt="Kappa"
                        className="chat-image chat-line__message--emote"
                        src="https://static-cdn.jtvnw.net/emoticons/v2/25/default/dark/1.0"
                        srcSet="https://static-cdn.jtvnw.net/emoticons/v2/25/default/dark/1.0 1x,https://static-cdn.jtvnw.net/emoticons/v2/25/default/dark/2.0 2x,https://static-cdn.jtvnw.net/emoticons/v2/25/default/dark/3.0 4x"
                      />
                    </div>
                  </span>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div className="chat-line__message" style={{ marginTop: '5px' }}>
        <div className="chat-line__message-container">
          <div
            className="chat-line__no-background"
            style={{ display: 'inline' }}
          >
            <div
              className="chat-line__username-container"
              style={{ display: 'inline-block' }}
            >
              {!!user.showIcons && (
                <span style={{ display: 'inline' }}>
                  <div style={{ display: 'inline' }}>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        borderRadius: 0,
                        color: 'inherit',
                        font: 'inherit',
                        padding: '0 2px 0 0',
                      }}
                    >
                      <img
                        alt="Prime Gaming"
                        aria-label="Prime Gaming badge"
                        className="chat-badge"
                        src="https://static-cdn.jtvnw.net/badges/v1/bbbe0db0-a598-423e-86d0-f9fb98ca1933/1"
                        srcSet="https://static-cdn.jtvnw.net/badges/v1/bbbe0db0-a598-423e-86d0-f9fb98ca1933/1 1x, https://static-cdn.jtvnw.net/badges/v1/bbbe0db0-a598-423e-86d0-f9fb98ca1933/2 2x, https://static-cdn.jtvnw.net/badges/v1/bbbe0db0-a598-423e-86d0-f9fb98ca1933/3 4x"
                      />
                    </button>
                  </div>
                </span>
              )}
              <span className="chat-line__username" role="button" tabIndex="0">
                <span>
                  <span
                    className="chat-author__display-name"
                    style={{
                      color: 'rgb(255, 0, 0)',
                      fontSize: `${user.size}px`,
                      letterSpacing: `${user.letterSpacing}px`,
                      textShadow: `0px 0px ${user.shadowSize}px ${user.shadowColor}`,
                      position: 'relative',
                      top: '-3px',
                    }}
                  >
                    pdro_sk8
                  </span>
                </span>
              </span>
            </div>
            <span
              aria-hidden="true"
              style={{
                position: 'relative',
                top: '-3px',
              }}
            >
              :{' '}
            </span>
            <span
              data-a-target="chat-line-message-body"
              style={{
                display: 'inline',
                color: message.color,
                fontSize: `${message.size}px`,
                letterSpacing: `${message.letterSpacing}px`,
                textShadow: `0px 0px ${message.shadowSize}px ${message.shadowColor}`,
              }}
            >
              <span
                className="text-fragment"
                style={{
                  position: 'relative',
                  top: '-3px',
                }}
              >
                cuanto es en €????
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="chat-line__message">
        <div className="chat-line__message-container">
          <div
            className="chat-line__no-background"
            style={{ display: 'inline' }}
          >
            <div
              className="chat-line__username-container"
              style={{ display: 'inline-block' }}
            >
              {!!user.showIcons && (
                <span style={{ display: 'inline' }}>
                  <div style={{ display: 'inline' }}>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        borderRadius: 0,
                        color: 'inherit',
                        font: 'inherit',
                        padding: '0 3px 0 0',
                      }}
                    >
                      <img
                        alt="GLHF Pledge"
                        aria-label="GLHF Pledge badge"
                        className="chat-badge"
                        src="https://static-cdn.jtvnw.net/badges/v1/3158e758-3cb4-43c5-94b3-7639810451c5/1"
                        srcSet="https://static-cdn.jtvnw.net/badges/v1/3158e758-3cb4-43c5-94b3-7639810451c5/1 1x, https://static-cdn.jtvnw.net/badges/v1/3158e758-3cb4-43c5-94b3-7639810451c5/2 2x, https://static-cdn.jtvnw.net/badges/v1/3158e758-3cb4-43c5-94b3-7639810451c5/3 4x"
                      />
                    </button>
                  </div>
                </span>
              )}
              <span className="chat-line__username" role="button" tabIndex="0">
                <span>
                  <span
                    className="chat-author__display-name"
                    style={{
                      color: 'rgb(139, 88, 255)',
                      fontSize: `${user.size}px`,
                      letterSpacing: `${user.letterSpacing}px`,
                      textShadow: `0px 0px ${user.shadowSize}px ${user.shadowColor}`,
                      position: 'relative',
                      top: '-3px',
                    }}
                  >
                    joselitoo_00
                  </span>
                </span>
              </span>
            </div>
            <span
              aria-hidden="true"
              style={{
                position: 'relative',
                top: '-3px',
              }}
            >
              :{' '}
            </span>
            <span
              data-a-target="chat-line-message-body"
              style={{
                display: 'inline',
                color: message.color,
                fontSize: `${message.size}px`,
                letterSpacing: `${message.letterSpacing}px`,
                textShadow: `0px 0px ${message.shadowSize}px ${message.shadowColor}`,
              }}
            >
              <span
                className="text-fragment"
                style={{
                  position: 'relative',
                  top: '-3px',
                }}
              >
                Grande
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="chat-line__message" style={{ marginTop: '5px' }}>
        <div className="chat-line__message-container">
          <div
            className="chat-line__no-background"
            style={{ display: 'inline' }}
          >
            <div
              className="chat-line__username-container"
              style={{ display: 'inline-block' }}
            >
              {!!user.showIcons && (
                <span style={{ display: 'inline' }}>
                  <div style={{ display: 'inline' }}>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        borderRadius: 0,
                        color: 'inherit',
                        font: 'inherit',
                        padding: '0 2px 0 0',
                      }}
                    >
                      <img
                        alt="Prime Gaming"
                        aria-label="Prime Gaming badge"
                        className="chat-badge"
                        src="https://static-cdn.jtvnw.net/badges/v1/bbbe0db0-a598-423e-86d0-f9fb98ca1933/1"
                        srcSet="https://static-cdn.jtvnw.net/badges/v1/bbbe0db0-a598-423e-86d0-f9fb98ca1933/1 1x, https://static-cdn.jtvnw.net/badges/v1/bbbe0db0-a598-423e-86d0-f9fb98ca1933/2 2x, https://static-cdn.jtvnw.net/badges/v1/bbbe0db0-a598-423e-86d0-f9fb98ca1933/3 4x"
                      />
                    </button>
                  </div>
                </span>
              )}
              <span className="chat-line__username" role="button" tabIndex="0">
                <span>
                  <span
                    className="chat-author__display-name"
                    style={{
                      color: 'rgb(0, 255, 127)',
                      fontSize: `${user.size}px`,
                      letterSpacing: `${user.letterSpacing}px`,
                      textShadow: `0px 0px ${user.shadowSize}px ${user.shadowColor}`,
                      position: 'relative',
                      top: '-3px',
                    }}
                  >
                    ibai
                  </span>
                </span>
              </span>
            </div>
            <span
              aria-hidden="true"
              style={{
                position: 'relative',
                top: '-3px',
              }}
            >
              :{' '}
            </span>
            <span
              data-a-target="chat-line-message-body"
              style={{
                display: 'inline',
                color: message.color,
                fontSize: `${message.size}px`,
                letterSpacing: `${message.letterSpacing}px`,
                textShadow: `0px 0px ${message.shadowSize}px ${message.shadowColor}`,
              }}
            >
              <span
                className="text-fragment"
                style={{
                  position: 'relative',
                  top: '-3px',
                }}
              >
                soy el mejor en only up!
              </span>
            </span>
          </div>
        </div>
      </div>
    </ExampleContainer>
  );
}

TwitchExample.propTypes = {
  styles: PropTypes.shape({
    user: PropTypes.shape({
      letterSpacing: PropTypes.number,
      showIcons: PropTypes.bool,
      size: PropTypes.number,
    }),
    message: PropTypes.shape({
      color: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

TwitchExample.defaultProps = {
  styles: {
    user: {
      letterSpacing: 1,
      showIcons: true,
      size: 15,
    },
    message: {
      color: '#efeff1',
      letterSpacing: 1,
      size: 15,
    },
  },
};

export default TwitchExample;
